module.exports = __webpack_public_path__ + "img/eye-dropper.97fd7fb5.svg";